// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qznvwqjxrbjcgqwdvrzb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bnZ3cWp4cmJqY2dxd2R2cnpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODg0NTUxNzgsImV4cCI6MjAwNDAzMTE3OH0.qqVR9KsAslY5gPewFWIyb5UnC8T0g4AEGkxXY-BKdss";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);